import React, { useEffect, useRef, useState } from 'react'

import {
    Link,
    Navigate
} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import secureLocalStorage from "react-secure-storage";

import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image'

import { toast } from 'react-toastify';

import { setAuth } from '../actions';
import { fetchToken } from '../firebase';
import { fetchRequest, ROOT_URL } from '../fetchRequest';

import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';

import FoodSale from './foodSale'
import ShopModal from './shopModal'
import ChargeModal from './chargeModal'
import NfcCheckModal from './nfcCheckModal'

const Container = ({ }) => {
    const dispatch = useDispatch();
    const mountedRef = useRef(false);
    const { currentUser } = useSelector((state) => state.auth);
    const [printReceipt, setPrintReceipt] = useState(true);
    const [loading, setLoading] = useState(false);

    const [isFoodScreenShown, setIsFoodScreenShown] = useState(true);
    const [isShopScreenShown, setIsShopScreenShown] = useState(false);
    const [isChargeScreenShown, setIsChargeScreenShown] = useState(false);
    const [isNfcCheckShown, setIsNfcCheckShown] = useState(false)

    const [fcmToken, setFcmToken] = useState(null);
    const [notificationEnabled, setNotificationEnabled] = useState(false);

    const [posModal, setPosModal] = useState(false);
    const [tmpPosPort, setTmpPosPort] = useState('');
    const [tmpPosTerminal, setTmpPosTerminal] = useState('');

    const [posDisable, setPosDisable] = useState(false);

    const loadNotificationSettings = () => {
        if (!("Notification" in window)) {
            toast.warning("Мэдэгдэл илгээх боломжгүй browser байна", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
        } else if (Notification.permission === "granted") {
            setNotificationEnabled(true);
            if (!fcmToken) {
                fetchToken(setFcmToken);
            }
        } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    setNotificationEnabled(true);
                    if (!fcmToken) {
                        fetchToken(setFcmToken);
                    }
                } else {
                    setNotificationEnabled(false);
                }
            });
        } else {
            toast.warning("Мэдэгдэл илгээх тохиргоог хаасан байна.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });
        }
    }

    const loadMain = () => {
        setLoading(true);
        fetchRequest("app/main", 'POST', {
            school: currentUser?.school,
        })
            .then(res => {
                if (res?.user) {
                    dispatch(setAuth({
                        ...currentUser, ...{
                            schoolName: res?.schoolName || '',
                            schoolRegister: res?.registerNo || null,
                            schoolContact: res?.schoolContact || null,
                            showHistory: res?.showHistory || false,
                            golomtPos: res?.golomtPos || false,
                            canCharge: res?.canCharge || false,
                            hasEbarimt: res?.hasEbarimt || false
                        }
                    }));
                    setIsFoodScreenShown(true);
                    setIsShopScreenShown(false);
                    setIsChargeScreenShown(false);
                    setIsNfcCheckShown(false)
                    setLoading(false);
                } else {
                    toast.warning('Хандах эрх дууссан байна. Дахин нэвтэрнэ үү', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    secureLocalStorage.setItem("eKioskFoodUsages", '');
                    window.location.replace("/logout");
                }
            }).catch(e => {
                setLoading(false);
                toast.warning('Хандах эрх дууссан байна. Дахин нэвтэрнэ үү', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                secureLocalStorage.setItem("eKioskFoodUsages", '');
                window.location.replace("/logout");
            })
    }

    useEffect(() => {
    }, [isFoodScreenShown])

    useEffect(() => {
        if (!mountedRef?.current) {
            mountedRef.current = true;
            loadNotificationSettings();
            loadMain();
        }
    }, []);

    const CustomProfile = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <Image
                className="icon-profile"
                src={`/assets/images/ic_profile.png`} />
        </a>
    ));

    const closeShopModal = () => {
        setIsShopScreenShown(false);
        setIsFoodScreenShown(true);
    }

    const closeChargeModal = () => {
        setIsFoodScreenShown(true);
        setIsChargeScreenShown(false)
    }

    const closeNfcCheckModal = () => {
        setIsFoodScreenShown(true);
        setIsNfcCheckShown(false)
    }

    const updatePosData = () => {
        secureLocalStorage.setItem("eKioskPosPort", tmpPosPort);
        secureLocalStorage.setItem("eKioskPosTerminal", tmpPosTerminal);

        toast.success('ПОС тохиргоо хадгалагдлаа', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
        })

        setPosModal(false)
    }

    const loadPosData = () => {
        setTmpPosPort(secureLocalStorage.getItem("eKioskPosPort"));
        setTmpPosTerminal(secureLocalStorage.getItem("eKioskPosTerminal"));

        setPosModal(true);
    }

    const posSettlement = () => {

        const posPort = secureLocalStorage.getItem("eKioskPosPort");
        const posTerminal = secureLocalStorage.getItem("eKioskPosTerminal");

        const posSubmitParams = {
            requestID: "",
            portNo: posPort,
            timeout: "540000",
            terminalID: posTerminal,
            amount: "",
            currencyCode: "496",
            operationCode: "59",
            bandWidth: "115200",
            cMode: "",
            cMode2: "",
            additionalData: "",
            cardEntryMode: "",
            fileData: ""
        }
        setPosDisable(true);

        fetch("http://localhost:8500/requestToPos/message?data=" + btoa(JSON.stringify(posSubmitParams)))
            .then((response) => response.json())
            .then((responseData) => {
                const posSubmitResult = unescape(responseData?.PosResult);
                if (posSubmitResult) {
                    const submitRes = JSON.parse(posSubmitResult);
                    const submitResData = atob(submitRes?.data);
                    if (submitRes?.responseCode === '00') {
                        toast.success('ПОС settlement амжилттай хийгдлээ', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        })
                    } else {
                        setPosDisable(false);
                        alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                    }
                } else {
                    setPosDisable(false);
                    alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                }
            }).catch((submitError) => {
                setPosDisable(false);
                console.log('Err', submitError)
            });
    }

    return (
        <>
            <Navbar bg="light" expand="lg" className='e-navbar'>
                <Link to="/dashboard">
                    <Image
                        className="icon-dashboard"
                        src={`/assets/images/ic_dashboard.png`} />
                </Link>
                <div style={{ flex: 1 }} className="text-center">
                    {
                        currentUser?.canCharge && <Button type={'button'} className='btn-hover-white btn-link' style={{ color: 'white' }} onClick={() => {
                            document.activeElement.blur();
                            setIsFoodScreenShown(false);
                            setIsChargeScreenShown(true);
                        }}>
                            Карт цэнэглэх
                        </Button>
                    }
                </div>
                <Dropdown
                    align={{ lg: 'end' }}
                    autoClose={true}
                >
                    <Dropdown.Toggle as={CustomProfile} id="dropdown-c`ustom-components">
                        {currentUser?.person?.firstName}
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ width: 250 }}>
                        <h4 className='p-10'>{currentUser?.person?.firstName}</h4>
                        <div style={{ padding: 10, width: '100%', cursor: 'pointer' }} onClick={() => {
                            window.location.reload();
                        }}>
                            <div style={{
                                width: 40,
                                display: 'inline-block',
                                textAlign: 'center'
                            }}>
                                <Image
                                    className="icon-dropdown"
                                    src={`/assets/images/ic_refresh.png`} />
                            </div>
                            Дахин ачааллах
                        </div>
                        <div style={{ padding: 10, width: '100%', cursor: 'pointer' }} onClick={() => {
                            setIsFoodScreenShown(false);
                            setIsNfcCheckShown(true);
                        }}>
                            <div style={{
                                width: 40,
                                display: 'inline-block',
                                textAlign: 'center'
                            }}>
                                <Image
                                    className="icon-dropdown"
                                    src={`/assets/images/ic_search.png`} />
                            </div>
                            NFC шалгах
                        </div>
                        <div style={{ padding: 10 }}>
                            <Form>
                                <Form.Check
                                    type="switch"
                                    id="receipt_switch"
                                    label="Талон хэвлэх"
                                    checked={printReceipt}
                                    onChange={(e) => {
                                        setPrintReceipt(e.target.checked)
                                        dispatch(setAuth({ ...currentUser, ...{ receipt: e.target.checked } }));
                                    }}
                                />
                            </Form>
                        </div>
                        {
                            currentUser?.golomtPos && <div style={{ padding: 10, width: '100%', cursor: 'pointer' }}
                                onClick={loadPosData}>
                                <div style={{
                                    width: 40,
                                    display: 'inline-block',
                                    textAlign: 'center'
                                }}>
                                    <Image
                                        style={{ height: 25 }}
                                        src={`/assets/images/pos.png`} />
                                </div>
                                POS тохиргоо
                            </div>
                        }
                        {
                            currentUser?.golomtPos && <div style={{ padding: 10, width: '100%', cursor: 'pointer' }}
                                onClick={posSettlement}>
                                <div style={{
                                    width: 40,
                                    display: 'inline-block',
                                    textAlign: 'center'
                                }}>
                                    <Image
                                        style={{ height: 25 }}
                                        src={`/assets/images/pos.png`} />
                                </div>
                                POS settlement
                            </div>
                        }
                        <div style={{ width: '100%'}} className="text-center">
                            <pre>v1.0.4</pre>
                        </div>
                        <hr />
                        <div style={{ padding: 10 }}>
                            <a href="/logout" style={{ textDecoration: 'none' }}>
                                <div style={{
                                    width: 40,
                                    display: 'inline-block',
                                    textAlign: 'center'
                                }}>
                                    <Image
                                        className="icon-dropdown"
                                        src={`/assets/images/ic_exit.png`} />
                                </div>
                                Гарах
                            </a>
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </Navbar>

            <div className="home-content-container">
                {
                    isFoodScreenShown && <FoodSale
                        pageFocused={isFoodScreenShown}
                    />
                }
            </div>
            <div className="basket-footer-container m-0">
                <div style={{ flex: 1 }}></div>
                <div>
                    <p className='basket-label m-0'><span>Энд дарж худалдан</span><span>авалтаа хийгээрэй.</span></p>

                    <Image
                        className="icon-arrow-next"
                        src={`/assets/images/ic_arrow_next.png`} />

                    <Button type={'button'}
                        className='btn-basket' onClick={() => {
                            document.activeElement.blur();
                            setIsShopScreenShown(true);
                            setIsFoodScreenShown(false);
                            // loadShop();
                        }}>
                        <Image
                            alt='shop'
                            className="icon-basket"
                            src={`/assets/images/ic_basket.png`} />
                    </Button>
                </div>
            </div>

            {
                isShopScreenShown
                && <ShopModal
                    pageFocused={isShopScreenShown}
                    onCloseShopModal={closeShopModal}
                />
            }

            {
                isChargeScreenShown
                && <ChargeModal
                    fcmToken={fcmToken}
                    pageFocused={isChargeScreenShown}
                    onCloseChargeModal={closeChargeModal}
                />
            }

            {
                isNfcCheckShown 
                && <NfcCheckModal 
                    pageFocused={isChargeScreenShown}
                    onCloseNfcModal={closeNfcCheckModal}
                    />
            }

            <Modal
                show={posModal}
                centered
                backdrop="static"
                onHide={() => {
                    setPosModal(false)
                }}>
                <Modal.Header>
                    POS тохиргоо
                </Modal.Header>
                <Modal.Body>
                    <Row className={'mt-20'}>
                        <label>Port No:</label>
                        <InputGroup className="mb-3">
                            <Form.Control aria-label="USB port number"
                                onChange={(e) => {
                                    setTmpPosPort(e.target.value)
                                }}
                                value={tmpPosPort}
                                placeholder="USB port number" />
                        </InputGroup>
                    </Row>
                    <Row className={'mt-20'}>
                        <label>Terminal number:</label>
                        <InputGroup className="mb-3">
                            <Form.Control aria-label="Terminal number"
                                onChange={(e) => {
                                    setTmpPosTerminal(e.target.value)
                                }}
                                value={tmpPosTerminal}
                                placeholder="Terminal number" />
                        </InputGroup>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row style={{ width: '100%' }}>
                        <Col className="text-center">
                            <Button type={'button'} className='btn-gray'
                                style={{
                                    marginTop: 20,
                                    marginRight: 20,
                                    padding: '15px 50px'
                                }}
                                onClick={() => {
                                    setPosModal(false)
                                }}>
                                Цуцлах
                            </Button>
                            <Button variant="" type={'button'} className='btn btn-main' onClick={updatePosData}>
                                Хадгалах
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default Container;